<template>
  <v-alert
    v-if="type === 'alert' && value"
    type="error"
    transition="scale-transition"
    class="info-alert"
    dismissible
    :value="showMessage"
    @input="clearMessage"
  >
    {{ value.message }}
  </v-alert>
  <v-dialog :value="showMessage" @input="clearMessage" v-else width="400">
    <v-card>
      <v-card-title class="headline mb-3">
        <h4>Meeting has not started yet.</h4>
      </v-card-title>
      <v-card-text v-if="value && value.data">
        <p class="mb-2">
          Meeting will begin
          <strong
            ><i>{{ getMeetingStart(value.data.start_time) }}</i></strong
          >.
        </p>
        <p>Leave this tab open and we'll autojoin you</p>
        <countdown
          :endTime="+value.data.start_time"
          class="mt-2"
          @finish="joinRoom"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDistance } from 'date-fns';
import { eventBus } from '@/lib/events';
import Countdown from './Countdown';

export default {
  name: 'ErrorMessage',
  components: {
    Countdown,
  },
  props: {
    value: {},
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.initMessage();
      }
    },
  },
  data() {
    return {
      type: '',
      showMessage: false,
    };
  },
  computed: {
    isNotStarted() {
      return this.value?.data?.error === 'not_started';
    },
  },
  methods: {
    initMessage() {
      this.type = this.isNotStarted ? 'dialog' : 'alert';
      this.showMessage = true;
    },
    getMeetingStart(timestamp) {
      return formatDistance(new Date(timestamp * 1000), new Date(), {
        addSuffix: true,
      });
    },
    clearMessage() {
      this.showMessage = false;
      this.$emit('input', null);
    },
    joinRoom() {
      eventBus.trigger('joinRoom');
      this.clearMessage();
    },
  },
};
</script>

<style lang="less">
.v-alert.info-alert {
  max-width: 420px;
  position: fixed !important;
  z-index: 100;
  top: 12px;
  right: 12px;
  margin-bottom: 0;
  padding: 12px;

  .v-alert__content {
    font-size: 14px;
  }
}
</style>
